import Box from 'ext-ui/components/Box/Box'
import Button from 'ext-ui/components/Button/Button'
import ArrowIcon from 'ext-ui/svg/icon/ArrowIcon'
import CreditCardGradientIcon from 'ext-ui/svg/icon/CreditCardGradientIcon'
import React from 'react'
import SvgClose from 'src/components/Svgs/SvgClose'
import { useTranslate } from 'src/localization/Trns'

import style from './EnableVirtualCardSuccessCTA.style'

interface EnableVirtualCardSuccessCTAProps {
  onCreateClick?: () => void
  onDismiss?: () => void
}

const EnableVirtualCardSuccessCTA: React.FC<
  EnableVirtualCardSuccessCTAProps
> = ({ onCreateClick, onDismiss }) => {
  const translate = useTranslate()

  return (
    <Box css={style} className="EnableVirtualCardSuccessCTA">
      <button
        className="close-button"
        onClick={onDismiss}
        aria-label={translate('Dismiss')}
      >
        <SvgClose />
      </button>
      <div className="flex-row align-start gap-4">
        <CreditCardGradientIcon />
        <div className="text-button-content flex-column gap-5 flex-1">
          <div className="flex-column gap-2">
            <p className="font-h4 font-weight-medium text-primary">
              {translate("You're now enabled for virtual cards")} {'🎉'}
            </p>
            <p className="create-text">
              {translate(
                'Create and send virtual cards to manage company spend.',
              )}
            </p>
          </div>
          <Button
            className="cta-button flex-row justify-center align-center gap-2"
            variant="secondary"
            onClick={onCreateClick}
          >
            {translate('Create your first card')}
            <ArrowIcon aria-hidden="true" />
          </Button>
        </div>
      </div>
    </Box>
  )
}

export default EnableVirtualCardSuccessCTA
